// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { Cart } from "@insite/client-framework/Services/CartService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import { CartsState } from "@insite/client-framework/Store/Data/Carts/CartsState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import { CustomAppState } from "@west/App/Store/Reducers";

export const getIsCheckoutPages = (state: ApplicationState, includeOrderConfirmationPage = true) => {
    const isCheckoutPage =
        getCurrentPage(state).type === "CheckoutShippingPage" ||
        getCurrentPage(state).type === "CheckoutReviewAndSubmitPage" ||
        getCurrentPage(state).type === "OnePageCheckoutPage";

    const isOrderConfirmationPage =
        getCurrentPage(state).type === "OrderConfirmationPage" ||
        getCurrentPage(state).type === "OnePageCheckoutConfirmationPage";

    if (includeOrderConfirmationPage) {
        return isCheckoutPage || isOrderConfirmationPage;
    }

    return isCheckoutPage;
};

export const getIsPlaceOrderDisabled = (state: ApplicationState, cart?: Cart) => {
    const shippingAddressState = state.pages.onePageCheckout.shippingAddressFormState?.address.state;
    const currentUserIsGuest = getCurrentUserIsGuest(state);
    const shipTo = getShipToState(state, cart?.shipToId)?.value;

    const isPlacingOrder = state.pages.onePageCheckout.isPlacingOrder;

    const isCaliforniaState = currentUserIsGuest
        ? shippingAddressState?.name?.toLowerCase() === "california" ||
          shippingAddressState?.abbreviation?.toLowerCase() === "ca"
        : shipTo?.state?.name?.toLowerCase() === "california" || shipTo?.state?.abbreviation?.toLowerCase() === "ca";

    const isCartEmpty = !cart || (cart.cartLines && cart.cartLines.length <= 0) || !cart?.cartLines;

    const isSavedShippingAddress = getIsSavedShippingAddress(state);

    return (
        isPlacingOrder ||
        isCaliforniaState ||
        isCartEmpty ||
        cart?.paymentOptions?.paymentMethods?.length === 0 ||
        !isSavedShippingAddress
    );
};

export const getIsSavedShippingAddress = (state: ApplicationState) => {
    return (state as CustomAppState).xOnePageCheckout.isShippingEditing
        ? state.pages.onePageCheckout.paymentDetailsState === "active"
        : true;
};
